import React, {useMemo} from "react";
import Styles from "../../pages/Campaigns/SoundManager/soundManager.module.scss";
import {Input} from "@kaleyra/emmy";
import {DOMAIN_VALIDATION_REGEX, TITLE_VALIDATION_REGEX} from "../../constants";
import ErrorImage from "../ErrorImage/ErrorImage";
import {useTranslation} from "react-i18next";

interface Props {
    title:string|undefined,
    label:string,
    placeholder?:string,
    setTitle: any,
    disable?:boolean,
    maxCharLimit?:number,
    minCharLimit?:number,
    bottomLabel?:string|undefined,
    bottomLabelType?:'error'|'default'|'success'|undefined,
    [key:string]:any
}

const StandardTitle = (props:Props) => {
    const { title, setTitle, label='mainTitle', placeholder='mainTitle', disable = false, minCharLimit=3, maxCharLimit=75,
    allowSpaceInRegex = true, allowLeadingAndTrailingHyphensUnderscores = true,bottomLabel,bottomLabelType,  ...properties } = props;
    const REGEX = !allowSpaceInRegex ? DOMAIN_VALIDATION_REGEX : TITLE_VALIDATION_REGEX;
    const { t } = useTranslation();
    const titleValidateLabelType = useMemo(() => {
        if(bottomLabelType) return bottomLabelType;
        if( title === undefined) return 'default';
        let regex = REGEX.test(title);
        const val = title.trim();
        if (val.length < minCharLimit || regex) return 'error';
        if(!allowLeadingAndTrailingHyphensUnderscores && val
            && (['_','-'].indexOf(val[0]) >= 0 || ['_','-'].indexOf(val[val.length -1]) >= 0) ) return 'error';
        return 'default';
    },[title,bottomLabelType]);

    const titleValidateLabel = useMemo( () => {
        if(bottomLabel) return <ErrorImage title={bottomLabel} />
        const val = title;
        if (val === undefined) return <ErrorImage hideIcon={true} type="warning"
                                                  title={t(allowSpaceInRegex ? 'titleSpcCharNotAllowed' : 'KLR00482')}/>;
        if (!val || val.trim().length === 0) return <ErrorImage title={t('titleReq')}/>;
        else if (REGEX.test(val)) return <ErrorImage title={t(allowSpaceInRegex ? 'titleSpcCharNotAllowed' : 'KLR00482')}/>;
        else if (val.trim().length < minCharLimit) return <ErrorImage title={t('min3Char')}/>;
        else if (val.trim().length > maxCharLimit) return <ErrorImage title={t('KLR00436')}/>;
        if (!allowLeadingAndTrailingHyphensUnderscores && val &&
            (['_', '-'].indexOf(val[0]) >= 0 || ['_', '-'].indexOf(val[val.length - 1]) >= 0)) return <ErrorImage
            title={t('KLR00483')}/>;
        return <ErrorImage hideIcon={true} type="warning" title={t(allowSpaceInRegex ? 'titleSpcCharNotAllowed' : 'KLR00482')}/>;
    },[title,bottomLabel]);

    return(
        <>
            <Input
                {...properties}
                label={t(label)}
                value={title}
                onChange={(e) => {
                    let val = e.target.value;
                    setTitle((val||"").slice(0,maxCharLimit));
                }}
                placeholder={t(placeholder)}
                className={Styles.mrgBtm}
                disabled={disable}
                style={{backgroundColor: titleValidateLabelType === "error" ? "rgba(241, 108, 123, 0.1)" : ""}}
                bottomLabel={!disable ? titleValidateLabel : undefined}
                bottomLabelType={!disable ? titleValidateLabelType : undefined}
                showBottomLabelSpace={!disable}
            />
        </>
    )
}

export default StandardTitle;
